export default __webpack_public_path__ + "static/media/Well-written Logo.6ab0af7d.png";